import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Order from '../views/Order.vue'
import Advancesearch from '../views/Advancesearch.vue'
import VendorAssignment from '../views/VendorAssignment.vue'
import Roles from '../views/Roles.vue'
import NProgress from 'nprogress'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'orders',
    component: Home
  },
  {
    path: '/orders',
    name: 'orderspage',
    component: Home
  },
  {
    path: '/advance-search',
    name: 'advancesearch',
    component: Advancesearch
  },
  {
    path: '/vendor-assignment',
    name: 'vendorassignment',
    component: VendorAssignment
  },
  {
    path: '/order/:uid',
    name: 'order',
    component: Order
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/roles',
    name: 'roles',
    component: Roles
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
    NProgress.set(0.1)
  }
  let authenticated = !(localStorage.getItem('ID_TOKEN_KEY') == null)
  let luser = localStorage.getItem('auth')
  try {
    luser = JSON.parse(luser)
    luser = luser['user_data']['is_superuser']
  } catch (e) {
    luser = false
  }
  // alert(luser)
  if (to.path === '/login') {
    if (authenticated) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else if (to.path === '/roles') {
    if (!luser) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else {
    if (authenticated) {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  }
})
router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  if (from.name) {
    setTimeout(() => {
      NProgress.done()
    }, 400)
  }
})
Vue.nextTick(function () {
  setTimeout(() => {
    NProgress.done()
  }, 400)
})
export default router
